module.exports = new __parcel__URL__("slant-phrases.bcd7c8b4.mp4").toString();